export const BASE_DEV_URL = window.location.hostname.includes("localhost")
  ? "https://jeetindia.online/api/v1"
  : `${window.location.origin}/api/v1`;

export const BASE_URL = window.location.hostname.includes("localhost")
  ? "https://jeetindia.online/api/v1"
  : `${window.location.origin}/api/v1`;

// export const BASE_DEV_URL = window.location.hostname.includes("localhost")
//   ? "https://captain365.online/api/v1"
//   : `${window.location.origin}/api/v1`;

// export const BASE_URL = window.location.hostname.includes("localhost")
//   ? "https://captain365.online/api/v1"
//   : window.location.origin;

// export const BASE_DEV_URL = window.location.hostname.includes("localhost")
//   ? "https://usabet9.com/api/v1"
//   : `${window.location.origin}/api/v1`;

// export const BASE_URL = window.location.hostname.includes("localhost")
//   ? "https://usabet9.com/api/v1"
//   : window.location.origin;

export const OTP_VERIFY = true;
export const B2B = false;

//brandname without subdomain
export const BRAND_NAME_WITHOUT_SUBDOMAIN = () => {
  if (typeof window === "undefined") return "";
  const hostname = String(window.location.hostname || "")
    .trim()
    .toLowerCase();

  if (!hostname) return "";

  // localhost / IPs: no "brand" concept, return as-is
  if (hostname === "localhost") return "localhost";
  const isIPv4 = /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname);
  if (isIPv4) return hostname;

  const parts = hostname.split(".").filter(Boolean);
  if (parts.length === 1) return parts[0];

  // Most domains: use second-level label (example.com -> example, jeetindia.online -> jeetindia).
  // Handle common ccTLD patterns like example.co.uk -> example.
  const last = parts[parts.length - 1];
  const secondLast = parts[parts.length - 2];
  const COMMON_SLD_UNDER_CCTLD = new Set([
    "ac",
    "co",
    "com",
    "edu",
    "gov",
    "net",
    "org",
  ]);

  const looksLikeCcTld = last.length === 2;
  if (
    looksLikeCcTld &&
    COMMON_SLD_UNDER_CCTLD.has(secondLast) &&
    parts.length >= 3
  ) {
    return parts[parts.length - 3];
  }

  return secondLast;
};

//for balance
export const getBalanceInterval = 5000;

//in category page like cricket, football, racing, etc.
export const sportWiseMatchesFecthInterval = 2000;
export const horseAndGreyhoundMatchesFecthInterval = 2000;

//sports detail page
export const getSportDetailForMarketODDSAndFencyMarketInterval = 1200;
export const openBetsFetchInterval = 30000;
export const fancyLiabilityAndTeamPositionFetchInterval = 60000;

//racing detail page
export const getRacingDetailFanciesAndMatchDetailsInterval = 1200;
export const racingOpenBetsFetchInterval = 30000;
export const racingTeamPositionAndFancyLiabilityFetchInterval = 60000;
